module.exports = __webpack_public_path__ + "static/media/half-circle.e3156472.png";